import type { Ref } from "vue";

export enum StatusType {
  base = "0",
  company = "1",
  user = "2",
}

export type Status = {
  id: string;
  enabled: boolean;
  is_deleted: string | null;
  item_id: number;
  label: string;
  order: number;
  type: StatusType;
};

export type StatusesResponse = {
  statuses: {
    id: string;
    enabled: "0" | "1";
    is_deleted: string | null;
    label: string;
    type: StatusType;
    item_id: string;
    order: string;
  }[];
};

export type CreateStatusRequest = {
  enabled: boolean;
  item_id: number;
  label: string;
  locationGroupPk?: string | null;
  type: string;
};

export type UpdateStatusRequest = {
  id: string;
  enabled?: 0 | 1;
  order?: number;
  label?: string;
  locationGroupPk?: Ref<string | null>;
};

export type UpdateStatusResponse = {
  httpCode: number;
  id: number;
  order: number;
  success: boolean;
};

export type UpdateStatusOrderRequest = {
  id: string;
  order: string;
  locationGroupPk?: Ref<string | null>;
};

export type StatusErrorResponse = {
  errors: {
    attribute: string;
    code: number;
    details: string;
    lineNumber: null;
    locations: boolean;
    status: number;
    title: string;
  }[];
  httpCode: number;
  success: boolean;
};
